<template>
  <p class="text-sm text-muted-foreground font-medium  leading-5">
    <slot />
  </p>
</template>